<template>
  <div class="mb-5">
    <v-row>
      <v-col cols="12" sm="12" md="12" class="remove-space-around mt-3">
        <v-autocomplete
          :value="currentProperty"
          :items="properties"
          item-value="id"
          item-text="name"
          class="to-upper"
          :label="$t('rentals.property_name')"
          return-object
          no-filter
          :search-input.sync="searchQuery"
          :error-messages="errorMessages"
          :required="required"
          clearable
          @input="onInput"
        >
          <template slot="selection" slot-scope="{ item }">
            {{ getPropertyName(item) }}
          </template>
          <template slot="item" slot-scope="{ item }">
            <v-list-item-content>
              <p class="client_name">
                {{ getPropertyName(item) }}
              </p>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- <v-col cols="12" sm="6" md="7" class="remove-space-around">
        <AddressInput
          :value="propertyAddressValue"
          :disabled="false"
          :label="$t('address')"
        />
      </v-col> -->
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [Object, String],
      default: null,
    },
    property: {
      type: Object,
      default: null,
    },
    properties: {
      type: Array,
      default: () => [],
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    currentProperty() {
      return this.value !== undefined && this.value !== null
        ? this.value
        : this.property;
    },
    propertyIdentifier() {
      return (
        this.currentProperty?.property_identifier ||
        this.currentProperty?.identifier ||
        this.currentProperty?.reference ||
        this.currentProperty?.code ||
        ""
      );
    },
    propertyAddress() {
      const address = this.currentProperty?.address;
      if (address && typeof address === "object") {
        return (
          address.formatted ||
          address.label ||
          address.street ||
          address.address ||
          ""
        );
      }
      return (
        address ||
        this.currentProperty?.street_address ||
        this.currentProperty?.address1 ||
        this.currentProperty?.address_1 ||
        this.currentProperty?.street ||
        ""
      );
    },
    propertyZip() {
      return (
        this.currentProperty?.zip ||
        this.currentProperty?.zipcode ||
        this.currentProperty?.postal_code ||
        this.currentProperty?.zip_code ||
        ""
      );
    },
    propertyCity() {
      const city = this.currentProperty?.city;
      if (!city) {
        return "";
      }
      return typeof city === "object" ? city.name || city.value || "" : city;
    },
    propertyCountry() {
      const country =
        this.currentProperty?.country ||
        this.currentProperty?.country_name ||
        this.currentProperty?.country_code;
      if (country) {
        return typeof country === "object"
          ? country.name || country.value || ""
          : country;
      }
      return this.currentProperty?.country_id || "";
    },
    // propertyDropdownItems() {
    //   return this.currentProperty ? [this.currentProperty] : [];
    // },
    propertyAddressValue() {
      const address = this.currentProperty?.address;
      if (address && typeof address === "object") {
        const formatted = address.formatted || address.label;
        if (formatted) {
          return { formatted };
        }
        const street =
          address.street ||
          address.address ||
          address.address_1 ||
          address.address1 ||
          address.street_address ||
          "";
        const zip =
          address.zip ||
          address.zipcode ||
          address.postal_code ||
          address.zip_code ||
          "";
        const city =
          typeof address.city === "object"
            ? address.city?.name || address.city?.value || ""
            : address.city || "";
        const country =
          address.country_code || address.country || address.country_name || "";
        return {
          formatted: [street, zip, city, country].filter(Boolean).join(", "),
        };
      }

      const formatted = [
        this.propertyAddress,
        this.propertyZip,
        this.propertyCity,
        this.propertyCountry,
      ]
        .filter(Boolean)
        .join(", ");
      return { formatted };
    },
  },
  data() {
    return {
      searchQuery: "",
      searchDebounceTimer: null,
    };
  },
  watch: {
    searchQuery: {
      handler(val) {
        if (!val || typeof val === "object") return;
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = setTimeout(() => {
          this.$emit("search", val);
        }, 500);
      },
    },
  },
  methods: {
    getPropertyName(property) {
      if (!property) {
        return "";
      }
      if (typeof property === "string") {
        return property;
      }
      return property.name || property.property_name || "";
    },
    onInput(val) {
      if (!val) this.searchQuery = "";
      this.$emit("input", val);
    },
  },
};
</script>
<style scoped>
.remove-space-around {
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  padding-top: 0px;
}
</style>
